module.exports = __webpack_public_path__ + "static/screen-android-mobile@2x-f6aacee9b4220eecf277ef89f0a1c345.png";